/**
 * O nome do app e uma brincadeira com o salgado, entao a tela de entrada conta
 * curiosidades sobre ele enquanto a pessoa digita. Frases curtas de proposito:
 * quem esta entrando quer entrar, nao ler um artigo.
 */
export const CURIOSIDADES = [
  'Calzone é um prato da culinária italiana.',
  'O nome quer dizer "calça" ou "meia" em italiano.',
  'Nasceu em Nápoles, no século XVIII.',
  'É, essencialmente, uma pizza dobrada ao meio.',
  'Foi criado para se comer andando pela rua.',
  'O recheio clássico leva ricota e presunto.',
  'A borda é selada com os dedos, antes de assar.',
  'Panzerotti é o primo menor, e frito.',
  'Em Nápoles, o tamanho tradicional é individual.',
  'A massa é a mesma da pizza napolitana.',
  'O vapor de dentro é que cozinha o recheio.',
  'Molho de tomate, na Itália, costuma vir à parte.',
  'Stromboli é parente, mas é enrolado, não dobrado.',
  'Um furo na massa evita que ele estufe demais.',
  'Chegou aos Estados Unidos com os imigrantes italianos.',
] as const;

/** De quanto em quanto tempo a frase troca, em milissegundos. */
export const INTERVALO_CURIOSIDADE = 6000;
